<template>
	<div>
		<div class="checkbox-radios mb-3">
			<base-radio v-for="(el_opt, el_index) in rb_options" :key="el_index" :name="el_opt.name" v-model="rb_model" inline>{{el_opt.label}}</base-radio>
		</div>
		<div>
			<ReInputSearchDrop 
				:disabled="rb_model=='2'?false:true"
				:findId="findId"
				:name="name"
				:placeholder="placeholder"
				v-model="search_model"
				:objApiMethod="objApiMethod"
				:strApiMethodKey="strApiMethodKey"
				:strType="strType"
				@change="onStaffSelect"
			/>
		</div>
	</div>
</template>

<script>
	import { BaseRadio } from 'src/components/index';
	import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
	export default {
		name: 'ReSearchTaskStaff',
		components: {
			BaseRadio,
			ReInputSearchDrop
		},
		props: {
			placeholder: String,
			name: String,
			objApiMethod: {
				type: Object,
				default() {	return {}; }
			},
			strApiMethodKey:{
				type: String,
				required: true
			},
			MinTxtLen: {
				type: Number,
				default:2,
			},
			value: [String, Number],
			strType:{
				type: String,
				default: 'staff',
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				rb_options: [
					{'name' : '0', 'label' : 'Все задачи'}, 
					{'name' : '1', 'label' : 'Мои задачи'},
					{'name' : '2', 'label' : 'Задачи сотрудника'}
				],
				rb_model: '0',
				search_model: {'inputText' : '', 'selectedVal' : ''},
				cat_timer: null,
			}
		},
		watch: {
			rb_model:function(val){
				if(val=='0'){
					this.search_model = {'inputText' : '', 'selectedVal' : ''};
					this.$emit('input', '');
					this.$emit('change', '');
				}
				if(val=='1'){
					this.search_model = {'inputText' : '', 'selectedVal' : this.$GVO.my_profile.code};
					this.$emit('input', this.$GVO.my_profile.code);
					this.$emit('change', this.$GVO.my_profile.code);
				}
				if(val=='2'){
					this.search_model = {'inputText' : '', 'selectedVal' : ''};
				}
			}
		},
		methods: {
			onStaffSelect(staff){
				this.$emit('input', staff.selectedVal);
				this.$emit('change', staff.selectedVal);
			},
			GetAgentName(){
				this.cat_timer = setInterval(() => {
					if(typeof this.value != 'undefined' && this.value != ''){
						if(typeof this.$GVO.GetCat('CAT_STAFF',this.value).name != 'undefined'){
							if(this.value != '' && typeof this.value != 'undefined'){
								this.search_model = {'inputText' : this.$GVO.GetCat('CAT_STAFF',this.value).name, 'selectedVal' : this.value};
							}
							clearTimeout(this.cat_timer);
							this.cat_timer = null;
						}else{
							this.search_model = {'inputText' : '', 'selectedVal' : this.value};
						}
					}else{
						clearTimeout(this.cat_timer);
						this.cat_timer = null;
					}
				}, 250);
				return this.$GVO.GetCat('CAT_STAFF',this.value).name;
			},
		},
		mounted(){
			if(this.value == '' || typeof this.value == 'undefined'){
				this.rb_model = '0';
			}else if(this.value == this.$GVO.my_profile.code){
				this.rb_model = '1';
			} else {
				this.rb_model = '2';
			}
			this.GetAgentName();
		}
	}
</script>
<style scoped>

</style>
